import { AutomationSettings } from 'ontime-types';

export const automationPlaceholderSettings: AutomationSettings = {
  enabledAutomations: false,
  enabledOscIn: false,
  oscPortIn: 8888,
  triggers: [],
  automations: {},
};
